export default {
    cash: 'Cash',
    financing: 'Financing',
    leasing: 'Leasing',
};
